import {
  Button,
  Icon,
  IconButton,
  RouterState,
  SidebarPriorityItem,
  useResponsiveValue,
} from '@monash/portal-react';
import { MOBILE_RESPONSIVE } from '../../Nav';
import c from './search-button.module.scss';
import { useContext } from 'react';
import {
  SEARCH_PLACEHOLDER,
  SearchContext,
} from '@/components/providers/SearchProvider';
import { isStringEmpty } from '@monash/portal-frontend-common';

const SearchButton = ({ isInSidebar = false, onClick }) => {
  const responsiveSize = useResponsiveValue(MOBILE_RESPONSIVE);
  const isMobile = responsiveSize === 'S' || responsiveSize === 'XS';

  const { redirect } = useContext(RouterState);
  const { searchTarget } = useContext(SearchContext);
  const searchPageUrl = `/search?query=${
    !isStringEmpty(searchTarget) ? searchTarget : ''
  }`;

  const ID = 'search';
  const TRACKING_LABEL = 'topnav-search';

  return (
    <div className={c.searchContainer}>
      {(() => {
        // Sidebar view
        if (isInSidebar) {
          return (
            <SidebarPriorityItem
              id={ID}
              aria-label={searchTarget || SEARCH_PLACEHOLDER}
              icon={<Icon.Search />}
              onClick={() => {
                redirect(searchPageUrl);
                onClick?.();
              }}
              data-tracking-event={TRACKING_LABEL}
            >
              {SEARCH_PLACEHOLDER}
            </SidebarPriorityItem>
          );
        }

        // Mobile view
        if (isMobile) {
          return (
            <IconButton
              id={ID}
              aria-label={searchTarget || SEARCH_PLACEHOLDER}
              className={c.searchButtonMobile}
              onClick={() => {
                redirect(searchPageUrl);
                onClick?.();
              }}
              icon={Icon.Search}
              data-tracking-event={TRACKING_LABEL}
            />
          );
        }

        // Regular view
        return (
          <Button
            size="medium"
            id={ID}
            aria-label={searchTarget || SEARCH_PLACEHOLDER}
            icon={<Icon.Search />}
            onClick={() => {
              redirect(searchPageUrl);
            }}
            className={c.searchButton}
            data-tracking-event={TRACKING_LABEL}
          >
            <span>{searchTarget || SEARCH_PLACEHOLDER}</span>
          </Button>
        );
      })()}
    </div>
  );
};

export default SearchButton;
